import ProductStickyHeader from './lib/ProductStickyHeader';

export default ProductStickyHeader;
